<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="12" fill="#F75712" />
  <path
    d="M11.0147 13.9179V6H13.0381V13.9179H11.0147ZM10.61 16.61C10.61 16.2229 10.739 15.8944 10.9971 15.6246C11.2669 15.3548 11.6012 15.2199 12 15.2199C12.3871 15.2199 12.7156 15.3548 12.9854 15.6246C13.2551 15.8944 13.39 16.2229 13.39 16.61C13.39 17.0088 13.2551 17.3431 12.9854 17.6129C12.7156 17.871 12.3871 18 12 18C11.6012 18 11.2669 17.871 10.9971 17.6129C10.739 17.3431 10.61 17.0088 10.61 16.61Z"
    fill="white" />
</svg>